import { render } from "./LogoFontAwesome.vue?vue&type=template&id=566ffd56"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/branding/LogoFontAwesome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "566ffd56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('566ffd56', __exports__)) {
    api.reload('566ffd56', __exports__)
  }
  
  module.hot.accept("./LogoFontAwesome.vue?vue&type=template&id=566ffd56", () => {
    api.rerender('566ffd56', render)
  })

}


export default __exports__